import { Route, Switch, useParams, useLocation } from 'react-router-dom'
import { useQuery } from 'react-query'
import { useEffect, useState } from 'react'
import { t } from 'ttag'

import { api } from '@h2/api'
import { Link } from '@h2/common/components/link'
import { ListWithDetail } from '@h2/components/containers/listWithDetail'
import { Text } from '@h2/components/typography/text'

import { AssignmentListing } from './assignmentListing'
import { AssignmentDetail } from './assignmentDetail'
import { AssignmentFilterGrid } from './components/assignmentFilterGrid'

import { AnimatedContainer } from '../commonComponents/animatedContainer'

const Assignments = ({ routeColor }) => {
  const { assignmentId } = useParams()
  const { status, userSelected = true } = useLocation().state || {}
  const [pageNum, setPageNum] = useState(1)
  const [numPerPage, setNumPerPage] = useState(25)
  const [filtersSet, setFiltersSet] = useState({
    assignments: {
      status,
      userSelected,
      assignedByCurrentUser: true,
      assignedByOtherUser: false,
      start: (pageNum - 1) * numPerPage,
      numPerPage
    }
  })
  const filter = {
    key: 'assignments',
    getData: filtersSet,
    setData: setFiltersSet
  }

  useEffect(() => {
    setFiltersSet(fs => {
      return {
        ...fs,
        [filter.key]: {
          ...fs[filter.key],
          start: (pageNum - 1) * numPerPage,
          numPerPage
        }
      }
    })
  }, [pageNum, numPerPage, filter.key])

  useEffect(() => {
    setPageNum(1)
  }, [numPerPage])

  const resultRenderer = ({ id, name, user, dateSubmitted, dateApproved }) => (
    <Link href={`/management/assignments/${id}`}>
      <Text size="medium" margin="0 0 6px 0">
        {name}
      </Text>
      <Text size="small" margin="2px 0">
        <Text size="small" weight="bold" as="span">{t`Assigned To:`}</Text> {user.name}
      </Text>
      <Text size="small" margin="2px 0">
        <Text size="small" weight="bold" as="span">{t`Status:`}</Text>{' '}
        {dateApproved ? t`Approved` : dateSubmitted ? t`Submitted` : t`Assigned`}
      </Text>
    </Link>
  )
  const { data, isFetching } = useQuery(
    [`assignmentListing`, filtersSet[filter.key]],
    () =>
      api.fetch(`/management/assignments`, {
        method: 'POST',
        body: {
          ...filtersSet[filter.key]
        }
      })
  )
  const routes = [
    {
      path: '/management/assignments',
      exact: true,
      render(props) {
        return (
          <AssignmentListing
            {...props}
            setPageNum={setPageNum}
            pageNum={pageNum}
            totalResults={data?.numResults ?? 0}
            setNumPerPage={setNumPerPage}
            numPerPage={numPerPage}
            results={data?.results}
            isFetching={isFetching}
          />
        )
      }
    },
    {
      path: '/management/assignments/:assignmentId',
      exact: true,
      render(props) {
        return (
          <ListWithDetail
            isFetching={isFetching}
            paramKey="assignmentId"
            results={data?.results}
            resultRenderer={resultRenderer}>
            <AssignmentDetail {...props} isFetching={isFetching} />
          </ListWithDetail>
        )
      }
    }
  ]

  return (
    <div>
      <AssignmentFilterGrid routeColor={routeColor} filter={filter} />
      <AnimatedContainer unconstrained={!assignmentId}>
        <Switch>
          {routes.map((route, idx) => (
            <Route
              key={idx}
              {...route}
              render={props => {
                return route.render({ ...props })
              }}
            />
          ))}
        </Switch>
      </AnimatedContainer>
    </div>
  )
}

export { Assignments }
